angular.module(NgAppName).directive('crRegistrationBlimp', [function(){
	return{
		restrict: 'A',
		scope: true,

		link: function(scope, element, attrs){
			Core.add_signup_link($(element[0]))
		}
	}
}]);
